import { useNavigate, useSearchParams } from "react-router";
import { EmailCode } from "./EmailCode.tsx";

export function SignIn() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-[clamp(30px,4.5vw,44px)]">Sign in</h1>
        <p className="text-ink-2">Use the email you verified. Schools, resellers and testers sign in the same way.</p>
        {params.get("expired") && <p role="alert" className="text-[15px] text-bad">That sign-in link has expired or was already used. Ask for a new code.</p>}
      </div>
      <EmailCode mode="signin" onDone={() => navigate("/account")} />
    </div>
  );
}
